import { render, staticRenderFns } from "./ranking-list.component.vue?vue&type=template&id=660940f9&scoped=true"
import script from "./ranking-list.component.vue?vue&type=script&lang=js"
export * from "./ranking-list.component.vue?vue&type=script&lang=js"
import style0 from "./ranking-list.component.vue?vue&type=style&index=0&id=660940f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660940f9",
  null
  
)

export default component.exports